// from elemental ui

import React, { Component } from 'react';
import { width } from './constants';
import { omit } from 'lodash';

export default class Container extends Component {
  static defaultProps = {
    gutter: width.gutter,
    maxWidth: width.container
  }

  render() {
    let { gutter, maxWidth } = this.props;
    let containerStyle = {
      marginLeft: 'auto',
      marginRight: 'auto',
      paddingLeft: gutter,
      paddingRight: gutter,
      maxWidth: maxWidth,
    };

    let clearfixStyle = { clear: 'both', display: 'table' };
    let props = omit(this.props, 'gutter', 'maxWidth', 'style');

    return this.props.clearfix ? (
      <div className="Container" style={Object.assign(containerStyle, this.props.style)} {...props}>
        <span style={clearfixStyle} />
        {this.props.children}
        <span style={clearfixStyle} />
      </div>
    ) : (
      <div className="Container" style={Object.assign(containerStyle, this.props.style)} {...props} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/container.js